import React, { Component } from "react";
import { connect } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { Route, Switch, Redirect } from "react-router-dom";
import { IntlProvider, addLocaleData } from "react-intl";
import { ContainerQuery } from "react-container-query";
// import DocumentTitle from 'react-document-title';
import { history } from "./store/configureAppStore";
import en from "react-intl/locale-data/en";
import fr from "react-intl/locale-data/fr";
import localeData from "./intl/data.json";
import {
  SignInPage,
  SignUpPage,
  ForgottenPasswordPage,
  VerifyResetPage,
} from "./pages";
import MainLayout from "./layouts/MainLayout";
import ProtectedRoute from "./hoc/ProtectedRoute";
import classNames from "classnames";
import { signOutUser } from "./store/auth/actions";

addLocaleData([...en, ...fr]);

const query = {
  "screen-xs": {
    maxWidth: 575,
  },
  "screen-sm": {
    minWidth: 576,
    maxWidth: 767,
  },
  "screen-md": {
    minWidth: 768,
    maxWidth: 991,
  },
  "screen-lg": {
    minWidth: 992,
    maxWidth: 1199,
  },
  "screen-xl": {
    minWidth: 1200,
    maxWidth: 1599,
  },
  "screen-xxl": {
    minWidth: 1600,
  },
};
class App extends Component {
  render() {
    const { siteLanguage, isAuthenticated, signOutUser } = this.props;

    return (
      <IntlProvider
        locale={siteLanguage}
        defaultLocale={siteLanguage}
        messages={localeData[siteLanguage]}
      >
        <ConnectedRouter history={history}>
          {/* <DocumentTitle title={pageTitle}> */}
          <ContainerQuery query={query}>
            {(params) => (
              <div className={classNames(params)}>
                <Switch>
                  <Route
                    name="Signin"
                    path="/:lang/signin"
                    render={(rest) => <SignInPage {...rest} />}
                  />
                  <Route
                    name="Signup"
                    path="/:lang/signup"
                    render={(rest) => <SignUpPage {...rest} />}
                  />
                  <Route
                    name="Forgotten"
                    path="/:lang/forgotten-password"
                    render={(rest) => <ForgottenPasswordPage {...rest} />}
                  />

                  <Route
                    exact
                    name="Verify"
                    path={"/:lang/resetverify/:resetToken"}
                    render={(rest) => <VerifyResetPage {...rest} />}
                  />
                  <ProtectedRoute
                    signOutUser={signOutUser}
                    path="/:lang"
                    component={MainLayout}
                    isAuthenticated={isAuthenticated}
                    siteLanguage={siteLanguage}
                    screen={classNames(params)}
                  />
                  <Redirect to={`/${siteLanguage || "en"}/everyone`} />
                </Switch>
              </div>
            )}
          </ContainerQuery>
          {/* </DocumentTitle> */}
        </ConnectedRouter>
      </IntlProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  siteLanguage: state.intl.siteLanguage,
  isAuthenticated: state.user.isAuthenticated,
  pageTitle: state.preferences.pageTitle,
});

const mapDispatchToProps = (dispatch) => ({
  signOutUser: (...args) => dispatch(signOutUser(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
